// extracted by mini-css-extract-plugin
module.exports = {"link":"SiteFooterLinkColumn_link__59v2L","linkText":"SiteFooterLinkColumn_linkText__CZc3_"};